module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/bg_top-22e28a9d5c6db66feaa35830cbae5273.png";